export default "__VITE_ASSET__DLEZMBzC__"